import { Button, ButtonGroup } from '@vds/buttons'
import { Icon } from '@vds/icons'
import { TileContainer } from '@vds/tiles'
import { Body, Title } from '@vds/typography'
import React, { useEffect, useState } from 'react'
import { isDesktop, isMobile } from 'react-device-detect'
import './EventWidget.scss'
import { Loader } from '@vds/loaders'
import Timeline from '../../CourseDetailsPage/CourseDetaileTimeLine/CourseDetaileTimeLine'
import { checkCapacity, decodeHTML, mapperForInProgressTime, replaceDate, timer24, navigateUsingLanguage, mapTopicsAndTags, TAG_RECORDED_EVENTS, formatEventTime } from '../../../utility/utils'
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { contentClick } from '../../../common/Analytics/GAWrapper';
import { getTimeZoneAbbreviation } from '../../../utility/utils'

const EventWidget = ({ isBefore, isDuring, isAfter, isRecorded, currentEvent, eventCxAemData,topicEnEsMaping}) => {
  const capacity = checkCapacity(currentEvent?.availableSeats,currentEvent?.seatLimit);
  const startDate = currentEvent?.startDate || currentEvent?.dateStart;
  const endDate =startDate + currentEvent?.duration*1000 ;
  const deadline = currentEvent?.enrollmentDeadline;
  const startTime = new Date(currentEvent.dateStart);
  const endTime = new Date(startTime.getTime() + currentEvent.duration * 1000);
  const nowTime = new Date();
  const [isDeadlineUpcoming, setIsDeadlineUpcoming] = useState(deadline && new Date(deadline).getDate() > new Date().getDate());
  const [isLastDay, setIsLastDay] = useState( deadline && new Date(deadline).getDate() == new Date().getDate());
  const [isSpaceLimitation, setIsSpaceLimitation] = useState(capacity>10);
  const [isSpaceLimitationAlmostFull, setIsSpaceLimitationAlmostFull] = useState(capacity<=10);
  const [isEventFull, setIsEventFull] = useState(currentEvent?.availableSeats<=0 && currentEvent?.seatLimit>0);
  const [isEventEnded, setIsEventEnded] = useState((isRecorded && isAfter) || isAfter);
  const [isDeadlinePassed, setIsDeadlinePassed] = useState(deadline && new Date(deadline).getTime() < new Date().getTime());
  const [isDefault, setIsDefault] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dateTimeFormat = formatEventTime(currentEvent);
  const [headline, setHeadline] = useState(dateTimeFormat);
  const [body, setBody] = useState(decodeHTML(eventCxAemData?.widgetMsg?.enrollOpenText));
  const [isEventStartingSoon, setIsEventStartingSoon] = useState(startDate-Date.now()< 24 * 60 * 60 * 1000 && startDate-Date.now()>0);
  const [timer, setTimer] = useState('        ');
  const [isInProgress, setIsInProgress] = useState(startDate <= Date.now() && endDate > Date.now());
  const [inProgressTime,setInProgressTime]=useState('');
  const [hoursLeft,setHoursLeft]= useState();
  const [minutesLeft, setMinutesLeft] = useState();
  const allEventsWithTimeZone = useSelector((state) => state.AdobeResources.allEventsWithTimeZone);
  const [updatedCiamSignInURL, setupdatedCiamSignInURL] = useState('');
  let event = allEventsWithTimeZone?.filter(e => e.id === currentEvent.id);  
  let lng = localStorage.getItem("lng") && localStorage.getItem("lng") === 'es' ? 'es' :'en';
  const [timelineData,setTimelineData] = useState([]);
  const courseTitleEnEs = allEventsWithTimeZone?.find(event => event.id === currentEvent?.id)?.title;
  let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const pastSuggestion = useSelector((state) => state.AdobeResources?.rawPastData) ?? null;
  const isPastEvent = pastSuggestion?.[currentEvent?.id];

  const formatDuration = (format, seconds, aemModuleData) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes);
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return minutes === 0 ? "" : format?.toLowerCase() === 'video' ? `${formattedMinutes.padStart(2, '0')}:${formattedSeconds}` : formattedMinutes  + aemModuleData?.plusvalue + " " + ( minutes >1 ? aemModuleData?.minstxt : aemModuleData?.mintxt);
  }

    useEffect(() => {
    if (window?.location?.search?.includes('utm_')) {
      console.log('innn')
        const utmUrl = `${window?.location?.search?.substring(1)}`;
        localStorage.setItem('utmUrl', utmUrl);
        setupdatedCiamSignInURL(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${utmUrl}`);
      } else {        
        if (localStorage.getItem('utmUrl')) {
          setupdatedCiamSignInURL(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${localStorage.getItem('utmUrl')}`);
        } else {
          console.log('dfdfd', lng)
          setupdatedCiamSignInURL(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}`);
        }
      }
      if (isRecorded) {
        let tempTimeLine = [];
        currentEvent?.modules?.map((item) => {
          const currentAemModule = eventCxAemData?.dynamicstates?.dynamicstates?.find((state) => { return state.key?.toLowerCase() === item?.format?.toLocaleLowerCase() })
          if (currentAemModule?.key?.length > 0) {
            var obj = {
              icon: currentAemModule?.courseicon,
              title: currentAemModule?.courselabel,
              status: currentAemModule?.notstartedtxt,
              duration: formatDuration(item?.format, item?.duration, currentAemModule)
            }
            tempTimeLine.push(obj);
          }
        })
        tempTimeLine.push({
          icon: 'award',
          title: '',
          status: '',
          duration: ''
        })
        setTimelineData(tempTimeLine)
      }
    }, [currentEvent, eventCxAemData])

const settingFilterForCategoryPage = () => {
      localStorage.setItem('find_event_filter', JSON.stringify({
        tags: currentEvent?.tags,
        skills: currentEvent?.skills,
        language: currentEvent?.locale
      }));
    navigateUsingLanguage("/category/events");
  }

  const settingRecordedFilterForCategoryPage = () => {
    const recordedEventTag = currentEvent?.tags?.find(tag => tag.startsWith("Recording-course:"));
    const courseId = recordedEventTag?.match(/course:(\d+)/)?.[1];
    if (courseId) {
      navigateUsingLanguage(`/course-details/course:${courseId}`);
    }
  }

  useEffect(() => {
    // if(isRecorded) {
    //   setHeadline('');
    //   setBody('')
    // }

    if (isDeadlinePassed) {
      setHeadline(decodeHTML(eventCxAemData?.widgetMsg?.enrollDlMsg))
      setBody('')
    }
    if ((isSpaceLimitation || isSpaceLimitationAlmostFull || (isLastDay && isSpaceLimitationAlmostFull)) && !isDeadlinePassed && endTime.getTime() > nowTime.getTime()) {
      setBody(decodeHTML(eventCxAemData?.widgetMsg?.enrollOpenText))
    }
    if (isDeadlineUpcoming || isLastDay) {
      const dateTimeString = new Date(new Date(event[0]?.enrollmentDeadline).toString())
      const enrollBeforeTxt = decodeHTML(eventCxAemData?.widgetMsg?.enrollBeforeTxt)
      const options = {month: "short", day: "numeric"}
      const datePart = dateTimeString.toLocaleDateString("en-US", options);
      const timePart = dateTimeString.toLocaleTimeString("en-US", {hour: "2-digit", minute: "2-digit", hour12:false});

      const [hours24, minutes] = timePart.split(':').map(Number);
      const ampm = hours24 >= 12 ? 'PM' : 'AM';
      let hours12 = hours24 % 12;
      if (hours12 === 0) { 
        hours12 = 12;
      }

    const formattedMinutes = minutes.toString().padStart(2, '0');
      let timeZone = getTimeZoneAbbreviation(dateTimeString, userTimeZone);
    setBody(enrollBeforeTxt.replace("[time]", `${hours12}:${formattedMinutes} ${ampm} ${timeZone}`).replace("[date]", datePart))

    }
    
    if (currentEvent?.availableSeats <= 0 && currentEvent?.seatLimit > 0) {
      setHeadline(decodeHTML(eventCxAemData?.widgetMsg?.eventFullText))
      setBody(decodeHTML(eventCxAemData?.widgetMsg?.regWaitlistText))
    }
    if (event[0]?.additionalStatus?.tagName == "REGISTRATION_CLOSED") {
      setHeadline(decodeHTML(eventCxAemData?.widgetMsg?.enrollDlMsg))
      setBody('')
    }
    if (endTime.getTime() < nowTime.getTime()) {
      setHeadline(decodeHTML(eventCxAemData?.widgetMsg?.eventEndMsg))
      setBody('')
    }
    if (endTime.getTime() < nowTime.getTime() && event[0]?.recording != null) {duration.timeInSeconds <= 0
      setHeadline(decodeHTML(eventCxAemData?.widgetMsg?.eventEndMsg))
      setBody(decodeHTML(eventCxAemData?.widgetMsg?.recordedMsg))
    }
    if(isEventStartingSoon){
   
      let timerFunction = setInterval(()=>{
        let result = timer24(moment(new Date()),moment(startDate));
        if(timer=='00:00:00'){
          clearInterval(timerFunction)
          setTimer('00:00:00');
          setIsEventStartingSoon(false); 
        }else{
          setTimer(result);
        }
        
      },1000)
    }

    if(isInProgress && currentEvent?.duration>0 ){
      let timer = ()=>{
        let momentEndTime = moment(endDate);
        setHoursLeft(Math.floor(moment.duration(momentEndTime.diff(moment())).asHours()));
        setMinutesLeft(Math.floor(moment.duration(momentEndTime.diff(moment())).minutes()));
        if (hoursLeft<=0 && minutesLeft<=0) {
          clearTimeout(timer);
          setInProgressTime('');
          setIsInProgress(false);
        }else{  
          const result = mapperForInProgressTime(hoursLeft,minutesLeft,eventCxAemData);
          setInProgressTime(result);
        }        
      }
      
      timer();
      setTimeout(timer,60000);
   }

  //  if (isEventFull) {
  //        setHeadline(decodeHTML(eventCxAemData?.widgetMsg?.eventFullText))
  //        setBody(eventCxAemData?.widgetMsg?.regWaitlistText)
  //      }
  });

  return (
    <TileContainer
      padding='24px'
      aspectRatio='none'
      width='100%'
      height='100%'
      backgroundColor='rgba(243, 237, 224, 1)'
    >
      {isLoading && <div className='loader-widget'><Loader
        active
        fullscreen={false}
        surface="light"
      />
      </div>}
      {!isLoading && <div className={isBefore ? '' : 'widget-container'}>
          {!isRecorded && <>
        <div>
          {isDeadlineUpcoming && !isEventFull && !isLastDay && !isEventEnded && !isDeadlinePassed && !isInProgress && (
            <div className={`n-displayFlex n-alignItemsCenter mb-2X${!isLastDay && !isSpaceLimitation && !isSpaceLimitationAlmostFull ? ' mb-4X' : ''}`}>
              <Icon size='small' name='warning' />
              <div className='ml-2X'><Body size='medium'>{decodeHTML(replaceDate(eventCxAemData?.widgetMsg?.enrollByDate,deadline))}</Body></div>
            </div>
          )}
          {isLastDay && !isEventFull && !isDeadlineUpcoming && !isEventEnded && !isDeadlinePassed && !isInProgress && (
            <div className={`n-displayFlex n-alignItemsCenter mb-2X${!isSpaceLimitation && !isSpaceLimitationAlmostFull ? ' mb-4X' : ''}`}>
              <Icon size='small' name='warning' />
              <div className='ml-2X'><Body size='medium'>{decodeHTML(eventCxAemData?.widgetMsg?.enrollLastDate)}</Body></div>
            </div>
          )}
          {capacity>0 && isSpaceLimitation && !isSpaceLimitationAlmostFull && !isEventEnded && !isDeadlinePassed && (
            <div className={`n-displayFlex n-alignItemsCenter mb-2X${!isSpaceLimitationAlmostFull ? ' mb-4X' : ''}`}>
              <Icon size='small' name='warning' />
              <div className='ml-2X'><Body size='medium'>{decodeHTML(eventCxAemData?.widgetMsg?.ltdSpaceAvlble)}</Body></div>
            </div>
          )}
          {capacity>0 && isSpaceLimitationAlmostFull && !isSpaceLimitation && !isEventEnded && !isDeadlinePassed && (
            <div className="n-displayFlex n-alignsItemCenter mb-2X mb-4X">
              <Icon size='small' name='warning' />
              <div className='ml-2X'><Body size='medium'>{decodeHTML(eventCxAemData?.widgetMsg?.ltdSpaceRmg)}</Body></div>
            </div>
          )}
          {isBefore && isEventStartingSoon && !isEventEnded && !isDeadlinePassed && !isInProgress &&(
            <div className="n-displayFlex n-alignItemsCenter mb-2X mb-4X">
              <Icon size='small' name='warning' />
              <div className='ml-2X'><Body size='medium'><div>{decodeHTML(replaceDate(eventCxAemData?.widgetMsg?.evntStart, timer)).slice(0,-9)}<b>{decodeHTML(replaceDate(eventCxAemData?.widgetMsg?.evntStart, timer)).slice(-9)}</b></div></Body></div>
            </div>
          )}
          {isInProgress && inProgressTime && !isEventEnded && !isDeadlinePassed && (
            <div className="n-displayFlex n-alignItemsCenter mb-2X mb-4X">
              <Icon size='small' name='warning' />
              <div className='ml-2X'><Body size='medium'><b>{decodeHTML(eventCxAemData?.widgetMsg?.evntProgressHrMin).slice(0,12)}</b>{decodeHTML(replaceDate(inProgressTime, hoursLeft, minutesLeft)).slice(12)}</Body></div>
            </div>
          )}
          <div className='mb-2X'>{isMobile ? <Title size='medium' bold>{headline}</Title> : <Title size='small' bold>{headline}</Title>}</div>
          <div><Body size='large'>{decodeHTML(body)}</Body></div>
        </div>
        {(!isMobile && !isDeadlinePassed && !isEventEnded && endTime.getTime() > nowTime.getTime() && event[0]?.additionalStatus?.tagName !== "REGISTRATION_CLOSED" && event[0]?.recording === null) && <div className='mt-6X'><ButtonGroup
          childWidth={'100%'}
          viewport={'desktop'}
          rowQuantity={{ desktop: 2 }}
          data={[
            {
              children: eventCxAemData?.regBannerButtons?.regButtonText,
              size: 'large',
              use: 'primary',
              width: 'auto',
              // onClick: () => alert('You clicked the Button example!'),
              onClick: () => {
                let updatedTopics = mapTopicsAndTags(currentEvent,eventCxAemData);
                contentClick(courseTitleEnEs,window.location.href,updatedTopics,'event_widget_body_register')},
              href: "/onboarding"
            },
            {
              children: eventCxAemData?.regBannerButtons?.signInText,
              size: 'large',
              use: 'textLink',
              width: 'auto',
              onClick: () =>  {location.href = updatedCiamSignInURL},
              // href: global.config.CIAM_SIGN_IN_URL
            },
          ]}
          alignment={'left'}
        /></div>}
         {(endTime.getTime() > nowTime.getTime() && isDeadlinePassed) || (isPastEvent) && <div className='mt-6X'><Button
          size="large"
          disabled={false}
          use="primary"
          onClick={() => {
             contentClick(courseTitleEnEs,window.location.href,mapTopicsAndTags(currentEvent,eventCxAemData),'events_widget_body_findSimilarEvent')
             settingFilterForCategoryPage()
            }}>
          {decodeHTML(eventCxAemData?.widgetMsg?.similarEventTxt)}
        </Button></div>}
        {(event[0]?.additionalStatus?.tagName == "REGISTRATION_CLOSED" || (endTime.getTime() < nowTime.getTime() && event[0]?.recording === null)) && <div className='mt-6X'><Button
          size="large"
          disabled={false}
          use="primary"
          onClick={() => {
             contentClick(courseTitleEnEs,window.location.href,mapTopicsAndTags(currentEvent,eventCxAemData),'events_widget_body_findSimilarEvent')
             settingFilterForCategoryPage()
            }}>
          {decodeHTML(eventCxAemData?.widgetMsg?.similarEventTxt)}
        </Button></div>}
        {endTime.getTime() < nowTime.getTime() && event[0]?.recording != null &&
          <div className='widget-button-group mt-6X'>
             {currentEvent?.tags?.some(tag => tag.startsWith("Recording")) === true && (<Button
              size="large"
              disabled={false}
              use="primary"
              width={'fit-content'}
              onClick={() => settingRecordedFilterForCategoryPage()}>
              {decodeHTML(eventCxAemData?.widgetMsg?.recEventTxt)}
            </Button>)}
            <Button
              size="large"
              disabled={false}
              use="secondary"
              width={'fit-content'}
              onClick={() => {
                contentClick(courseTitleEnEs,window.location.href,mapTopicsAndTags(currentEvent,eventCxAemData),'events_widget_body_findSimilarEvent')
                settingFilterForCategoryPage()
              }}>
              {decodeHTML(eventCxAemData?.widgetMsg?.similarEventTxt)}
            </Button>
          </div>}
          </>}
        {isRecorded && <Timeline items={timelineData} />}
      </div>}
    </TileContainer>
  )
}

export default EventWidget